import React from "react";
import PropTypes from "prop-types";
import { renderStars } from "../../helpers/reviewHelper";

const RatingSummary = ({ ratingData }) => {
    const { averageRating, reviewCount, starPercentages } = ratingData;

    return (
        <div className="review-detail">
            <h4>Customer Review</h4>
            <div className="total-rating">
                <span>{averageRating.toFixed(1)}</span> &nbsp;
                <span>{renderStars(averageRating)}</span> &nbsp;
                <span>({reviewCount} reviews)</span>
            </div>

            <div className="customer-review-list">
                {Object.keys(starPercentages)
                    .sort((a, b) => b - a)
                    .map((star) => (
                        <div key={star} className="customer-review-rating">
                            <span>{star} star</span>
                            <div className="review-bar">
                                <div className="review-fill-bar"
                                    style={{
                                        width: `${starPercentages[star]}%`
                                    }}
                                />
                            </div>
                            <span className="parsent-label">{parseInt(starPercentages[star], 10)}%</span>
                        </div>
                    ))}
            </div>
        </div>
    );
};

RatingSummary.propTypes = {
    ratingData: PropTypes.shape({
        averageRating: PropTypes.number.isRequired,
        reviewCount: PropTypes.number.isRequired,
        starPercentages: PropTypes.objectOf(PropTypes.number).isRequired,
    }).isRequired,
};

export default RatingSummary;
